import { Type } from "class-transformer";
import { Diary, Encounter, FacilityLocation, Fax, Note, ProviderLocationIdentifier } from "@harlowe/core";
import { TealCompReferral } from "./teal-comp-referral";
import { UserHeader, HarloweSupport } from "@harlowe/core";
import { Bill, Invoice } from "./finance";
import { ReceivedEmail, SentEmail } from "@harlowe/core";
import { MedicalBill } from "./medical-bill";

export class TealCompEncounter extends Encounter
{
    constructor
    (
        id: number,
        encounterCreationDate: Date,
        referral: TealCompReferral,
        public status: number

    )
    {
        super(id,encounterCreationDate);
        this.referral = referral;
    }

    @Type(() => TealCompReferral)
    referral: TealCompReferral;

    approvalReceived? : boolean;
    servicingProviderAuthSent? : boolean;
    savings:number = 0;
    requestedProvider? : FacilityLocation;
    @Type(() => FacilityLocation)
    proposedProvider? : FacilityLocation;
    @Type(() => FacilityLocation)
    confirmedProvider?: FacilityLocation;
    payerInvoice?: Invoice;
    payerMedicalBillImage?: HarloweSupport.File;

    @Type(() => MedicalBill)
    primaryMedicalBill?: MedicalBill;
    additionalMedicalBills: MedicalBill[] = [];
    
    estimatedProposedCost?:number;
    estimatedRequestedCost?: number;
    totalConfirmedCharges?:number;
    confirmedGain?: number;

    @Type(() => HarloweSupport.File)
    attachments : HarloweSupport.File[] = [];
    closureReason?:number;

    override getDisplayName(): string {
        return `Encounter ${this.id}`;
    }
}

export class TealCompEncounterDetails extends TealCompEncounter
{
    @Type(() => Note)
    notes: Note[] = [];
    @Type(() => Diary)
    diaries: Diary[] = [];
    @Type(() => SentEmail)
    sentEmails: SentEmail[] = [];
    
    @Type(() => ReceivedEmail)
    receivedEmails:ReceivedEmail[] = [];

    @Type(() => Fax)
    outboundFaxes: Fax[] = [];
    
}

export class TealCompEncounterUpdate
{
    constructor
    (
        encounterId: number
    )
    {

    }

    encounterCompletionDate? : Date;
    assignedToId?: number;
    servicingProviderAuthSent?: boolean;
    servicingProviderBillId?: number;
    payerInvoiceId?: number;
    medicalRecordsFileId? : number;
    medicalBillImageFileId? : number;
    medicalBillId?: number;
    proposedProviderId?: ProviderLocationIdentifier;
    confirmedProviderId?: ProviderLocationIdentifier;
    providerDiscountId?: number;

    estimatedProposedCost?: number;
    estimatedRequestedCost?: number;
}

export interface TealCompEncounterHeader
{
    id: number;
    referralState:string;
    assignedTo?: UserHeader;
    assignedToId?: number;
    createDate: Date;
    referralApproved: boolean;
    procedureType?: string;
    servicingProviderBillReceived: boolean;
    invoiced: boolean;
    savings: number;
    encounterStatus: string;
    bodyPart?: string;
    adjuster?: string;
    carrier?: string
    claimNumber?: string;
    party?: string;
    gain?: number;
    amountBilled?: number;
    amountToInvoice?: number;
    totalSavings?: number;
    serviceDate?:Date;
    processedDate?: Date;
    closureReason?: number;
}

export interface EncounterFinancials
{
    encounter: TealCompEncounterHeader;
    bills: Bill[];
    invoice: Invoice;
}

export class EncounterClosureReason
{
    constructor
    ( 
        public description: string,
        public closureReason: number,
        public id: number
    )
    {}

}

export class EncounterStatus
{
    constructor
    ( 
        public description: string,
        public status: number,
        public id: number
    )
    {}

}